import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { AssetInventoryService } from '../../services/asset-inventory.service';
import { AssetInventory } from '../../models/entities/asset-inventory';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';

@Component({
    selector: 'asset-inventory-list',
    templateUrl: './asset-inventory-list.component.html',
    styleUrls: ['./asset-inventory-list.component.scss']
})


export class AssetInventoryListComponent extends BasePage2<AssetInventory> {

    // Ffilters
    //------------------------------------
    includingClosed : boolean = false;
    //------------------------------------


    assetInventories: AssetInventory[] = [];
      

    constructor(
        protected toastr                 : ToastrService,
        protected assetInventoryService  : AssetInventoryService,
        protected router                 : Router,
        protected baseService            : BaseService,
        protected leanUtilsService       : LeanUtilsService, 
        protected location               : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'assetInventory';
    }

    ngAfterViewInit(){
        super.ngAfterViewInit();
        
        this.loadData();
    }
    


    initEntityContainer() {
        this.entityContainer = new EntityContainer(AssetInventory);
    }

    getRows(): AssetInventory[] {
        return this.assetInventories;
    }


    saveRow(row: AssetInventory): Promise<AssetInventory> {
        return null;
    }

    loadData() {
        this.selectedRow = null;
        this.assetInventoryService.assetInventoriesGet(this.includingClosed).then(result => {
            this.assetInventories = result;
        })
    }

    selectRow(assetInventory : AssetInventory){
        this.assetInventoryService.getAssetInventoryAssets(assetInventory.assetInventoryCode).then(result => {
            assetInventory.assets = result;
            this.selectedRow = assetInventory; 
        })
    }

    startAssetInventory(){
        this.assetInventoryService.assetInventoryProcess('create').then(result => {
            this.assetInventories.push(result);
            
        })
    }
}
